import React from 'react'

function PageAbout() {
    return (
        <div>
            <div className="row">
                <h1 className="col-md-6"> About Page </h1>
            </div>
            <div className='row'>
                <div className='col-12'>
                    Page is design to get the weather information based on the location.
                </div>
            </div>
        </div>
    )
}

export default PageAbout